import script from "./AppProcessoPje.vue?vue&type=script&setup=true&lang=js"
export * from "./AppProcessoPje.vue?vue&type=script&setup=true&lang=js"

import "./AppProcessoPje.vue?vue&type=style&index=0&id=4fdc9266&lang=scss"

const __exports__ = script;

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
